'use client';

import { createContext, FC, ReactNode } from 'react';

import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { getDateTimeFormatMapForLocale } from '@rover/utilities/datetime';

export type DateTimeFormatType = ReturnType<typeof getDateTimeFormatMapForLocale>;

export type I18nContextType = {
  DF: DateTimeFormatType;
  locale: Locale;
};

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export type I18nProviderProps = {
  value: I18nContextType;
  children: ReactNode;
};

// This provides a named export for the Provider, allowing import by server components
export const I18nContextProvider: FC<I18nProviderProps> = (props) => (
  <I18nContext.Provider {...props} />
);

export default I18nContext;
